import { Table } from "antd";
import { useTranslation } from "react-i18next";
export const PortfolioTypeSelectionComparison = () => {
  const {
    t
  } = useTranslation("terms", {
    keyPrefix: "portfolioTypes"
  });
  return <Table tableLayout="fixed" size="small" rowClassName="align-top" pagination={false} columns={[{
    title: "Feature",
    dataIndex: "feature",
    key: "feature",
    className: "bg-gray-50 font-bold"
  }, {
    title: t("hk.title") + " Portfolio",
    dataIndex: "hk",
    key: "hk"
  }, {
    title: t("global.title") + " Portfolio",
    dataIndex: "global",
    key: "global"
  }]} dataSource={[{
    key: "1",
    feature: "Geographic Coverage",
    hk: "Hong Kong",
    global: "Global"
  }, {
    key: "2",
    feature: "Risk Ratings",
    hk: "A B C D E",
    global: "A B C"
  }, {
    key: "3",
    feature: "Archetypes",
    hk: "6 customised archetypes for Hong Kong",
    global: "46 generic Global archetypes"
  }, {
    key: "4",
    feature: "Portfolio-Level Results",
    hk: "Aggregated MVAR, TTIP, Productivity Loss, Failure Probability",
    global: "Aggregated MVAR, TTIP, Productivity Loss, Failure Probability"
  }, {
    key: "5",
    feature: "Asset-Level Results",
    hk: "Simple Risk Ratings & MVAR",
    global: "Simple Risk Rating, MVAR, TIP, Failure Probability & Productivity Loss"
  }]} data-sentry-element="Table" data-sentry-component="PortfolioTypeSelectionComparison" data-sentry-source-file="PortfolioExportTypeSelectionComparison.tsx" />;
};